module.exports = __webpack_public_path__ + "static/jakob-70bd68563866a7737a62333d7c35f5e0.png";